import { Dialog } from '@avanta/shared/components/ui/Dialog';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';

type LeaveConversationDialogProps = {
  onConfirm: () => void;
};

export const LeaveConversationDialog = ({
  onConfirm,
}: LeaveConversationDialogProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.CHAT);

  return (
    <Dialog
      title={t('Chat.LeaveConfirm.title')}
      description={t('Chat.LeaveConfirm.body')}
      secondaryAction={{
        label: t('Chat.LeaveConfirm.cancel'),
        variant: 'terciary',
      }}
      primaryAction={{
        label: t('Chat.LeaveConfirm.confirm'),
        action: onConfirm,
        variant: 'terciary',
        className: 'text-red-500 hover:border-red-600 hover:bg-red-100',
      }}
      open
      hideClose
    />
  );
};
